import { render, staticRenderFns } from "./FastOffer.vue?vue&type=template&id=b5b1ac12&scoped=true"
import script from "./FastOffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FastOffer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FastOffer.vue?vue&type=style&index=0&id=b5b1ac12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b1ac12",
  null
  
)

export default component.exports